module.exports = __webpack_public_path__ + "media/images/emblems/Diessenhofen-da7ae3a5a29a8320f2c39fa1d8cab761.png";